const mustBePositivMoneyAmount = (value: string) => {
  return /^[0-9]+([\,\.][0-9]{1,2})?$/.test(value);
};

export default mustBePositivMoneyAmount;
